import { useEffect } from "react";

const PAGE_PATHS = {
  home: "/",
  portfolio: "/portfolio",
  team: "/our-team",
  industry: "/leadership",
  investment: "/investment",
  contact: "/contact",
};

const getCanonicalUrl = (slug, lang) => {
  const path = PAGE_PATHS[slug];
  if (!path) return null;
  const localizedPath = lang === "ja" ? (path === "/" ? "/ja/" : `/ja${path}`) : path;
  return `${window.location.origin}${localizedPath}`;
};

const PAGE_SEO = {
  en: {
    home: {
      meta_title: "Venture Capital Companies & Firms in Singapore | Saison Capital",
      meta_description:
        "Explore Saison Capital, a venture capital firm in Singapore investing in innovative startups and supporting founders across emerging markets.",
    },
    portfolio: {
      meta_title: "Venture Capital Portfolio | Startup Investments | Saison Capital",
      meta_description:
        "Explore Saison Capital’s venture capital portfolio, featuring startup investments in innovative companies and emerging businesses across global markets.",
    },
    team: {
      meta_title: "Saison Capital Team | Venture Capital Investors & Partners",
      meta_description:
        "Meet the Saison Capital team of experienced venture capital investors and partners supporting innovative startups and founders across emerging markets.",
    },
    industry: {
      meta_title: "Industry Leadership | Saison Capital",
      meta_description:
        "See how Saison Capital works with founders and industry leaders.",
    },
    investment: {
      meta_title: "Investment Thesis | Saison Capital",
      meta_description:
        "Learn how Saison Capital invests in early-stage companies and partners with founders.",
    },
    contact: {
      meta_title: "Contact Saison Capital",
      meta_description:
        "Contact Saison Capital to connect with our team, explore investment opportunities, partnerships, and learn more about our approach to supporting founders.",
    },
  },
};

export default function SeoHead({ slug, lang = "en" }) {
  useEffect(() => {
    const seo = PAGE_SEO[lang]?.[slug] || PAGE_SEO.en[slug];
    if (!seo) return;

    document.title = seo.meta_title;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", seo.meta_description);

    const canonicalUrl = getCanonicalUrl(slug, lang);
    if (canonicalUrl) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", canonicalUrl);
    }
  }, [slug, lang]);

  return null;
}
